import MetadataShowEditSelect from './MetadataShowEditSelect.vue'

/**
 * Crema-only selects of the former `@addf/addf-vue-base-components` package,
 * each one a MetadataShowEditSelect bound to one `metadata` list.
 */
function metadataSelect(
  name,
  { metadataKey, labelKey, defaultName, multiple = false }
) {
  return {
    name,
    extends: MetadataShowEditSelect,
    props: {
      metadataKey: { type: String, default: metadataKey },
      labelKey: { type: String, default: labelKey },
      name: { type: String, default: defaultName ?? null },
      multiple: { type: Boolean, default: multiple }
    }
  }
}

export default {
  BaseBankShowEditSelectSimple: metadataSelect('BaseBankShowEditSelectSimple', {
    metadataKey: 'banks',
    labelKey: 'bank_id',
    defaultName: 'banks_id'
  }),
  BaseCompanyShowEditSelectSimple: metadataSelect(
    'BaseCompanyShowEditSelectSimple',
    { metadataKey: 'companies', labelKey: 'company', defaultName: 'company_id' }
  ),
  BaseCountryShowEditSelectSimple: metadataSelect(
    'BaseCountryShowEditSelectSimple',
    { metadataKey: 'countries', labelKey: 'country' }
  ),
  BaseCustomerShowEditSelectSimple: metadataSelect(
    'BaseCustomerShowEditSelectSimple',
    {
      metadataKey: 'customers',
      labelKey: 'customer',
      defaultName: 'customer_id'
    }
  ),
  BaseEventTypeShowEditSelectSimple: metadataSelect(
    'BaseEventTypeShowEditSelectSimple',
    { metadataKey: 'event_types', labelKey: 'event_type' }
  ),
  BaseLanguageShowEditSelectSimple: metadataSelect(
    'BaseLanguageShowEditSelectSimple',
    { metadataKey: 'languages', labelKey: 'language' }
  ),
  BaseUserShowEditSelectSimple: metadataSelect('BaseUserShowEditSelectSimple', {
    metadataKey: 'users',
    labelKey: 'user',
    defaultName: 'user_id'
  }),
  BaseCompanyShowEditSelectMultiple: metadataSelect(
    'BaseCompanyShowEditSelectMultiple',
    { metadataKey: 'companies', labelKey: 'companies', multiple: true }
  ),
  BaseDocShowEditSelectMultiple: metadataSelect(
    'BaseDocShowEditSelectMultiple',
    {
      metadataKey: 'doc_types',
      labelKey: 'available_docs',
      multiple: true
    }
  ),
  BaseLanguageShowEditSelectMultiple: metadataSelect(
    'BaseLanguageShowEditSelectMultiple',
    { metadataKey: 'languages', labelKey: 'language', multiple: true }
  )
}
